export default {
  setAuthError: (state, error) => (state.authError = error),
  setPopupType: (state, type) => (state.popupType = type),
  setCurrentPhone: (state, phone) => (state.currentPhone = phone),
  setIsPopup: (state, isPopup) => (state.isPopup = isPopup),
  setRegError: (state, error) => (state.regError = error),
  setSavePhone: (state, phone) => (state.savePhone = phone)
}



// WEBPACK FOOTER //
// ./src/components/store/modules/auth/mutations.js